export default __webpack_public_path__ + "static/media/Days-left.d6aa4d24.svg";